
  import createMeisterIcons from '../src/createMeisterIcons';

  const Square5 = createMeisterIcons("square-5", [["path",{"fill":"currentColor","d":"M7 3.75C5.114 3.75 3.75 5.114 3.75 7v1.15h16.5V7A3.26 3.26 0 0 0 17 3.75zM3.75 17V9.65h11.5v10.6H7A3.26 3.26 0 0 1 3.75 17m13 3.25H17A3.26 3.26 0 0 0 20.25 17V9.65h-3.5zM2.25 7c0-2.714 2.036-4.75 4.75-4.75h10A4.76 4.76 0 0 1 21.75 7v10A4.76 4.76 0 0 1 17 21.75H7A4.76 4.76 0 0 1 2.25 17z","key":"a97ddd214ab605d243cdf559029d77c67a1b6b29","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Square5
  